import { useState } from "react";
import {
  AmazonItemsApi,
  RequestUpdateAmazonItemsStatusRequest,
  AmazonItemsUpdateAmazonItemsStatusPostRequest,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiUpdateAmazonItemsStatus = () => {
  const [resultUpdate, setResultUpdate] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const updateAmazonItemsStatus = async (
    req: RequestUpdateAmazonItemsStatusRequest
  ) => {
    setIsLoading(true);
    setError(null);

    try {
      setIsLoading(true);
      const config = createConfiguration();
      const request: AmazonItemsUpdateAmazonItemsStatusPostRequest = {
        req,
      };

      const api = new AmazonItemsApi(config);
      const response = await api.amazonItemsUpdateAmazonItemsStatusPost(
        request
      );
      setResultUpdate(response);
      return response;
    } catch (err) {
      setError("ステータス更新に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { updateAmazonItemsStatus, resultUpdate, error, isLoading };
};
